const PLATFORM_CONFIG = {
  appVersion: "2.1.3"
};

module.exports = PLATFORM_CONFIG;